import { createFileRoute } from "@tanstack/react-router";

import { ReportEditorPage } from "../../../workspaces/reports/pages/ReportEditorPage";

export const Route = createFileRoute("/_console/p/$org/$project/reports/new")({
  component: NewReportRoute,
});

function NewReportRoute() {
  return <ReportEditorPage target={{ kind: "new" }} />;
}
